
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.66 14.818V.33h-3.933v.97A8.207 8.207 0 0012.284 0C7.716 0 4 3.73 4 8.314c0 4.585 3.716 8.315 8.285 8.315a8.21 8.21 0 004.397-1.269c0 .128-.007.242-.007.32 0 2.409-1.957 4.373-4.358 4.373a4.336 4.336 0 01-2.306-.67l-1.945 3.418A8.21 8.21 0 0012.323 24c4.569 0 8.337-3.73 8.337-8.315 0-.178.011-.702 0-.867zm-8.375-2.13c-2.4 0-4.359-1.964-4.359-4.374 0-2.41 1.957-4.374 4.359-4.374 2.401 0 4.358 1.964 4.358 4.374 0 2.41-1.957 4.374-4.358 4.374z","fill":"#F45D48"}})])
          )
        }
      }
    